<!--
    componente: alertbar-system
    propriedades: {
        alertbar: recebe um objeto setando as configurações de exibição da barra de alert no sistema
    }
-->
<template>
    <div>
        <v-snackbar
            :color="alertbar.color"
            v-model="alertbar.show"
            :timeout="alertbar.time"
            :bottom="alertbar.bottom"
            :right="alertbar.right"
            :multi-line="alertbar.multi"
            >
            <div class="title font-weight-light" v-html="alertbar.text"></div>
        </v-snackbar>
    </div>
</template>
<script>
/* eslint-disable */
export default {
    props:{
        alertbar:{
            type: Object,
            default:{
                color: null,
                show: false,
                time: 10000,
                bottom: true,
                right: true,
                multi: true,
                text: ''
            }
        }
    },
    data (){
        return{

        }
    }
}
</script>
